<template>
    <div>
        <h2 class="color-primary mb-2">The Local Area</h2>

        <div v-if="loading">
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </div>
        <div v-if="!loading">
            <span v-if="!readMoreActive" v-html="description.length > charLimit ? description.slice(0, charLimit) + '...' : description"></span>
            <a v-if="!readMoreActive && description.length > charLimit" @click.prevent="toggleReadMore()" href="#">Read more</a>
            <span v-if="readMoreActive" v-html="description"></span>
            <a v-if="readMoreActive" @click.prevent="toggleReadMore()" href="#">Read less</a>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api';

export default defineComponent({
    name: 'LocalAreaDescription',
    props: {
        description: {
            type:  String,
            required: true
        },
        charLimit: {
            type: Number,
            required: false,
            default: 550
        }
    },
    setup() {
        const loading = ref(true);
        const readMoreActive = ref(false);

        onMounted(() => {
            init();
        });

        function init() {
            loading.value = false;
        }

        function toggleReadMore() {
            readMoreActive.value = !readMoreActive.value;
        }

        return {
            // Variables
            loading,
            readMoreActive,
            //Functions
            toggleReadMore
        }

    }
});
</script>
